import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { IndicadoresDropDown } from "../../../../../common/domain/models/indicadores_dropdown";

type State = {
  IdIndicador: number;
  idsIndicadores: number[];
  tipoPesquisa: number,
  status: number,
  pesquisa: string | Date | number | null,

};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setIdsIndicadores: (ids: number[]) => void,
  setTipoPesquisa: SetFunction<number>,
  setStatus: SetFunction<number>,
  setPesquisa: SetFunction<string | Date | number | null>,
};


export const initialFiltersValues: State = {
  IdIndicador: 0,
  idsIndicadores: [],
  tipoPesquisa: 0,
  pesquisa: "",
  status: 1,
};

export const useIndicadoresFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  idsIndicadores: [],
  setIdsIndicadores: (idsIndicadores) => set({ idsIndicadores }),
  setTipoPesquisa: (vfn) => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setStatus: (vfn) => SetFunctionImpl(set, 'status', vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set(initialFiltersValues),

}));